var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-page-details',{attrs:{"actions":_vm.actions},on:{"init":_vm.handleInit}},[_c('Details',{attrs:{"details":_vm.details}}),_c('TransactionSetting',{attrs:{"details":_vm.details}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }